module.exports = __webpack_public_path__ + "static/space_Persistent_ISR-8c4133977fe6f5148271a09fa86a1c6e.svg";